export default "/images/8c1d9687d9f5bea0a1ace68fa96cd946.png";